import { render, staticRenderFns } from "./CreateCategoryDropdown.vue?vue&type=template&id=1082f0e4&scoped=true"
import script from "./CreateCategoryDropdown.vue?vue&type=script&lang=js"
export * from "./CreateCategoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./CreateCategoryDropdown.vue?vue&type=style&index=0&id=1082f0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1082f0e4",
  null
  
)

export default component.exports